import { JSDOM } from "jsdom";
import { NextPage } from "next";
import { PageLayout, PageTypes } from "../layouts/page";
import { WebflowPage } from "../layouts/page/WebflowPage";
import { WEBFLOW_ABOUT_PAGE } from "../lib/constants";

interface AboutProps {
  html: string;
}

const About: NextPage<AboutProps> = ({ html }) => {
  return (
    <PageLayout pageType={PageTypes.NOPADDING} backgroundType={"blackout"}>
      <WebflowPage html={html} />
    </PageLayout>
  );
};

export default About;

export async function getStaticProps() {
  const response = await fetch(WEBFLOW_ABOUT_PAGE);
  const data = await response;
  const html = await data.text();
  const document = new JSDOM(html).window.document;
  const body = document.body.outerHTML;
  const title = document.title.toString();
  const stylesheets = [document.querySelector('link[rel="stylesheet"]').href];

  return { props: { html: { body, title, stylesheets } } };
}
